module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('span', {
    attrs: {
      "aria-label": "vi",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Gettysburg Battle Map, Day 3 The general tactical situation of both armies on the final day at Gettysburg, July 3, 1863.",
      "src": "Images/frn_fig_004.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("Gettysburg Battle Map, Day 3"), _c('br'), _vm._v("The general tactical situation of both armies on the final day at Gettysburg, July 3, 1863.")])])]), _vm._v(" "), _c('span', {
    attrs: {
      "aria-label": "vii",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Gettysburg East Cavalry Field 1Early positions of both sides on the East Cavalry Field during the early afternoon of July 3, 1863.",
      "src": "Images/frn_fig_005.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("Gettysburg East Cavalry Field 1"), _c('br'), _vm._v("Early positions of both sides on the East Cavalry Field during the early afternoon of July 3, 1863.")])])]), _vm._v(" "), _c('span', {
    attrs: {
      "aria-label": "viii",
      "id": "pviii",
      "role": "doc-pagebreak"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Gettysburg East Cavalry Field 2 The general tactical situation when Brigadier General George Armstrong Custer leads the daring saber charge of the 7th Michigan Cavalry straight north to push the encroaching Rebels back to buy precious time for the Union.",
      "src": "Images/frn_fig_006.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("Gettysburg East Cavalry Field 2"), _c('br'), _vm._v("The general tactical situation when Brigadier General George Armstrong Custer leads the daring saber charge of the 7th Michigan Cavalry straight north to push the encroaching Rebels back to buy precious time for the Union.")])])]), _vm._v(" "), _c('span', {
    attrs: {
      "aria-label": "ix",
      "id": "pix",
      "role": "doc-pagebreak"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Gettysburg East Cavalry Field 3Brigadier General George Armstrong Custer leads the saber charge of the 1st Michigan Cavalry straight north to hurl aside the strongest Confederate offensive effort of the day on the East Cavalry Field. Custer saved the day by leading this audacious saber attack to protect the strategic crossroads—the Hanover Road and the Low Dutch Road—and the two Union horse batteries that were in peril.",
      "src": "Images/frn_fig_007.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("Gettysburg East Cavalry Field 3"), _c('br'), _vm._v("Brigadier General George Armstrong Custer leads the saber charge of the 1st Michigan Cavalry straight north to hurl aside the strongest Confederate offensive effort of the day on the East Cavalry Field. Custer saved the day by leading this audacious saber attack to protect the strategic crossroads—the Hanover Road and the Low Dutch Road—and the two Union horse batteries that were in peril.")]), _c('span', {
    attrs: {
      "aria-label": "x",
      "id": "px",
      "role": "doc-pagebreak"
    }
  })])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d03dcc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/FrontOther01.vue
// module id = 69
// module chunks = 0